<agr-page>
  <mat-vertical-stepper linear id="stepper">
    <mat-step [stepControl]="applicationGroupNameFormGroup">
      <form [formGroup]="applicationGroupNameFormGroup">
        <ng-template matStepLabel
          >{{ 'wizard_step1EnterApplicationGroupName' | translate }}
        </ng-template>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'wizard_step1EnterApplicationGroupName' | translate }}</mat-label>
          <input
            matInput
            formControlName="appGroupNameCtrl"
            placeholder="{{ 'wizard_applicationGroup' | translate }}"
            required
          />
        </mat-form-field>
        <div>
          <button color="primary" mat-button matStepperNext>{{ 'wizard_next' | translate }}</button>
        </div>
      </form>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{
        'wizard_step2RegisterApplicationGroup' | translate
      }}</ng-template>
      <p>{{ 'wizard_createMessage' | translate }}</p>
      <ul class="app-highlights">
        <li>
          {{ 'wizard_applicationGroupTitled' | translate }}
          <b>{{ applicationGroupNameFormGroup.get('appGroupNameCtrl').valueChanges | async }}</b>
        </li>
      </ul>
      <div>
        <button mat-button matStepperPrevious>{{ 'wizard_back' | translate }}</button>
        <button mat-button (click)="stepper.reset()">{{ 'wizard_reset' | translate }}</button>
        <button mat-button color="primary" (click)="complete()">
          {{ 'wizard_complete' | translate }}
        </button>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ 'wizard_step3Complete' | translate }}</ng-template>
      <p>{{ 'wizard_registrationApplicationGroupSuccessMessage' | translate }}</p>
    </mat-step>
  </mat-vertical-stepper>
</agr-page>
